export const isInFullScreen = state => state.player.state.isInFullScreen;
export const isPlayerUIVisible = state => state.player.ui.isVisible;



// WEBPACK FOOTER //
// ./src/shared/selectors/player.js